var _circle, _path, _circle2, _path2, _circle3, _path3, _rect, _rect2, _path4, _circle4, _path5, _path6, _path7, _path8, _path9, _path10, _rect3, _rect4, _path11, _path12, _polygon, _path13, _polygon2, _path14, _circle5, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 856.74612,
    height: 690.55273,
    viewBox: "0 0 856.74612 690.55273",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 241.16712,
    cy: 361.99458,
    r: 97.20043,
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M386.53249,608.65667l23.90995,14.81627V523.32127L383.64223,506.714a10.396,10.396,0,0,1-4.53632-6.03867h0a10.39619,10.39619,0,0,1,7.42666,1.37447l23.90995,14.81627V478.03017a91.88994,91.88994,0,0,1,2.74357-22.28622,91.887,91.887,0,0,1,2.74356,22.28622v63.38739l35.27393-21.85809a17.28621,17.28621,0,0,1,9.38854-2.59016,17.287,17.287,0,0,1-6.49828,7.25439l-38.16433,23.64908V784.72363h-5.4871V629.92821L383.6422,613.321a10.396,10.396,0,0,1-4.53631-6.03865h0A10.39632,10.39632,0,0,1,386.53249,608.65667Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#ccc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.20043,
    cy: 370.24744,
    r: 97.20043,
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.089,616.90953,271.179,631.7258V531.57413l26.8002-16.60725a10.396,10.396,0,0,0,4.53633-6.03868h0a10.3963,10.3963,0,0,0-7.42666,1.37447l-23.91,14.81625V486.283a91.889,91.889,0,0,0-2.74357-22.28622,91.88751,91.88751,0,0,0-2.74355,22.28622v63.3874L230.418,527.81233a17.28624,17.28624,0,0,0-9.38856-2.59015,17.287,17.287,0,0,0,6.4983,7.25439l38.16417,23.64913V785.24651H271.179V638.18108l26.80019-16.60726a10.39591,10.39591,0,0,0,4.53633-6.03864h0A10.39645,10.39645,0,0,0,295.089,616.90953Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#ccc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.80827,
    cy: 167.35454,
    r: 167.35454,
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384.651,516.46034l-41.16685,25.50985V369.53432l46.14314-28.59343a17.89922,17.89922,0,0,0,7.81049-10.39707l.00008-.00008h-.00008a17.89974,17.89974,0,0,0-12.78675,2.36648l-41.16685,25.50983V291.55453a158.21125,158.21125,0,0,0-4.72373-38.37124,158.20777,158.20777,0,0,0-4.7237,38.37124v109.137L273.304,363.05739a29.76333,29.76333,0,0,0-16.16471-4.45962,29.76342,29.76342,0,0,0,11.18843,12.4902l65.709,40.71779V785.61383h9.44743V553.08444L389.62731,524.491a17.89918,17.89918,0,0,0,7.8105-10.39707l.00008-.00006h-.00008A17.89976,17.89976,0,0,0,384.651,516.46034Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.74612,
    y: 680,
    width: 790,
    height: 2,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 793.99423,
    y: 414.94336,
    width: 45.27441,
    height: 45.27444,
    transform: "translate(-281.00936 362.21678) rotate(-30)",
    fill: "#ff6584"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M825.415,476.67554l-23.6377-40.94141,40.94141-23.63721,23.6377,40.9419Zm-20.90527-40.209,21.63769,37.47656L863.624,452.30639l-21.63769-37.47705Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 617.1084,
    cy: 462.9685,
    r: 19,
    fill: "#d0cde1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M802.73533,587.69214a20,20,0,1,1,20-20A20,20,0,0,1,802.73533,587.69214Zm0-38a18,18,0,1,0,18,18A18,18,0,0,0,802.73533,549.69214Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M908.59718,789.27246h-184a8.50982,8.50982,0,0,1-8.5-8.5v-171a8.50982,8.50982,0,0,1,8.5-8.5h184a8.50982,8.50982,0,0,1,8.5,8.5v171A8.50982,8.50982,0,0,1,908.59718,789.27246Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#cb302f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M829.59572,795.27637h-26a8.50981,8.50981,0,0,1-8.5-8.5v-182.084a8.50981,8.50981,0,0,1,8.5-8.5h26a8.50982,8.50982,0,0,1,8.5,8.5v182.084A8.50982,8.50982,0,0,1,829.59572,795.27637Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M957.48374,584.34521c-1.075,17.64038-24.9038,30.54175-24.9038,30.54175s-22.086-15.69934-21.011-33.33972,24.90381-30.54175,24.90381-30.54175S958.5587,566.70483,957.48374,584.34521Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M958.563,639.38428c-17.64368-1.0199-30.61939-24.80835-30.61939-24.80835s15.63037-22.13489,33.274-21.115S991.837,618.26929,991.837,618.26929,976.20665,640.40417,958.563,639.38428Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "744.97 517.469 744.97 582.749 680.04 497.049 729.5 497.049 744.97 517.469",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M971.71925,733.9375a8.489,8.489,0,0,1-6.78467-3.36328L829.66017,552.0332a8.5,8.5,0,0,1,1.6416-11.9082l19.92676-15.09766a8.49846,8.49846,0,0,1,11.90771,1.64258L998.41066,705.21a8.5,8.5,0,0,1-1.6416,11.9082L976.8423,732.21582A8.45354,8.45354,0,0,1,971.71925,733.9375Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#cb302f"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 891.91929,
    y: 603.8247,
    width: 43,
    height: 43,
    transform: "translate(-363.89101 573.79961) rotate(-37.15004)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 734.6333,
    y: 469.68471,
    width: 45.27444,
    height: 45.27441,
    transform: "translate(-85.89891 991.64315) rotate(-75)",
    fill: "#d0cde1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M754.72557,526.58471l-45.66309-12.23535,12.23535-45.66406,45.66309,12.23535ZM711.5117,512.9353l41.7998,11.2002,11.2002-41.80079-41.79981-11.20019Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M562.376,632.723a11.38228,11.38228,0,0,0-1.1652-17.41438L542.847,467.27838,519.12064,474.333l25.61477,144.05863A11.44393,11.44393,0,0,0,562.376,632.723Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "412.742 669.489 426.619 669.489 433.224 615.964 412.742 615.964 412.742 669.489",
    fill: "#ffb8b8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M581.39569,770.24806h43.61336a0,0,0,0,1,0,0v16.85062a0,0,0,0,1,0,0H596.70481a15.30912,15.30912,0,0,1-15.30912-15.30912v-1.54149A0,0,0,0,1,581.39569,770.24806Z",
    transform: "translate(1034.7778 1452.62311) rotate(-180)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "316.779 647.875 329.786 652.713 354.636 604.848 335.44 597.707 316.779 647.875",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M482.69612,754.91941h43.61336a0,0,0,0,1,0,0V771.77a0,0,0,0,1,0,0H498.00524a15.30912,15.30912,0,0,1-15.30912-15.30912v-1.54149A0,0,0,0,1,482.69612,754.91941Z",
    transform: "translate(539.60105 1549.95881) rotate(-159.59643)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 387.84812,
    cy: 297.88794,
    r: 26.2388,
    fill: "#ffb8b8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M518.43419,469.95338c-.82162-24.16818,24.579-40.93443,45.95011-29.61853,2.72287,1.44175,30.8376,25.32762,31.89714,40.1611s3.1786,39.20276,3.1786,39.20276L629.127,741.14134l-63.572-3.1786,7.67745-64.59821-41.32183,65.69111-50.05882-15.92638,61.453-176.9422S519.67932,506.57933,518.43419,469.95338Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M518.93464,478.36717l4.0822,53.06862a2.20607,2.20607,0,0,0,2.19957,2.03686H543.1781a2.20606,2.20606,0,0,0,2.03729-3.05232L523.1715,477.35172A2.20606,2.20606,0,0,0,518.93464,478.36717Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M611.17541,623.52774a11.38225,11.38225,0,0,0-3.1952-17.15835l-35.56155-144.8639-22.73772,9.78285,42.29787,140.071a11.44393,11.44393,0,0,0,19.1966,12.16835Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#ffb8b8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M552.84054,448.70992s-7.41674,14.83348,0,41.32183S565.555,538.77032,565.555,538.77032s16.95254-10.59534,24.36928-7.41674S578.192,460.74269,578.192,460.74269,566.61448,435.99552,552.84054,448.70992Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M565.63205,406.70588c.35442-5.44444,7.22306-5.631,12.67879-5.68255s11.97836.14321,15.0654-4.35543c2.0401-2.973,1.65041-7.10032-.035-10.28779s-4.45773-5.639-7.18509-7.99742c-7.04139-6.08883-14.29842-12.12936-22.7522-16.02662s-18.36045-5.472-27.12787-2.3435c-10.77008,3.84308-25.32927,23.62588-26.5865,34.99176s3.28506,22.95252,10.94189,31.44586,25.18188,5.0665,36.21069,8.088c-6.7049-9.48964-2.2854-26.73257,8.45573-31.164Z",
    transform: "translate(-171.62694 -104.72363)",
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.80ad28e004e177ed9b9bb7f65d815a48.svg";
export { ForwardRef as ReactComponent };